var Instagram = {};

export { Instagram as __exports };
